import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import Routes from './Routes';
import store from './store';
import GlobalStyle from './global-styles';

// Modify global theme values here
const theme = {
	colors: {
		darkBackground: '#585858',
		lightBackground: '#fff',
		secondaryBackground: '#f2f2f2',
		primaryBackground: '#0070c0',
		darkText: '#000',
		whiteText: '#fff',
		secondaryText: '#f9f9f9',
		tertiaryText: '#7f7f7f',
		border: '#c0c0c0',
	},
	spacing: {
		gutter: '0.8rem',
		half: '0.4rem',
		quarter: '0.2rem',
	},
	fontSize: {
		normal: '1.1rem',
		larger: '1.25rem',
		smaller: '0.8rem',
	},
};

render(
	<React.StrictMode>
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<GlobalStyle />
				<Routes />
			</ThemeProvider>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root'),
);
